import { render } from "./MapProvider.vue?vue&type=template&id=6c7058b1&scoped=true"
import script from "./MapProvider.vue?vue&type=script&lang=js"
export * from "./MapProvider.vue?vue&type=script&lang=js"

import "./MapProvider.vue?vue&type=style&index=0&id=6c7058b1&scoped=true&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7058b1"]])

export default __exports__